import { Component, Input } from "@angular/core";

import { Command } from "../../interfaces";

@Component({
    selector: "command-bar",
    templateUrl: "./commandBar.tmpl.html",
    standalone: false
})
export class CommandBarComponent
{
    @Input() readonly commands: ReadonlyArray<Command>;
    @Input() dense: boolean;
    @Input() useMouseDown: boolean;
}
